import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { healthResponseSchema, type HealthResponse } from '@netdeck/contracts';
import { apiRequest } from '../../shared/api/client';

export const healthQueryKey = ['health'] as const;

/**
 * Состояние платформы.
 *
 * 503 — штатный ответ эндпоинта, когда зависимость недоступна, и он несёт
 * полноценное тело с указанием, что именно упало. Поэтому статус принимается
 * как валидный ответ: в интерфейсе это `degraded`, а не «ошибка запроса».
 * Ошибкой остаётся только недоступность самого api.
 */
export function useHealth(): UseQueryResult<HealthResponse, Error> {
  return useQuery({
    queryKey: healthQueryKey,
    queryFn: () => apiRequest('/health', healthResponseSchema, { acceptStatuses: [503] }),
    refetchInterval: 10_000,
    retry: false,
  });
}
